// SIDVION THEME JS v2

// ─────────────────────────────
// CART
// ─────────────────────────────

async function svAddToCart(variantId, qty, btn) {
  if (!variantId) return;
  const origText = btn ? btn.innerHTML : '';
  if (btn) { btn.disabled = true; btn.innerHTML = 'Adding...'; }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(qty) || 1 })
    });
    if (!res.ok) throw new Error('Cart add failed');
    await svUpdateCartCount();
    svShowNotif('\u2713 Item added to your bag!');
    if (btn) { btn.innerHTML = 'Added \u2713'; }
    setTimeout(() => { if (btn) { btn.innerHTML = origText; btn.disabled = false; } }, 2200);
  } catch (err) {
    console.error('[Sidvion] Cart error:', err);
    if (btn) { btn.innerHTML = 'Try again'; }
    setTimeout(() => { if (btn) { btn.innerHTML = origText; btn.disabled = false; } }, 2500);
  }
}

async function svUpdateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('.sv-cart-badge').forEach(el => { el.textContent = cart.item_count; });
  } catch (e) { /* silent */ }
}

function svShowNotif(message) {
  const notif = document.getElementById('sv-cart-notif');
  if (!notif) return;
  notif.textContent = message;
  notif.classList.add('show');
  clearTimeout(notif._timeout);
  notif._timeout = setTimeout(() => notif.classList.remove('show'), 3200);
}

// ─────────────────────────────
// MOBILE MENU
// ─────────────────────────────

var _svDocClickBound = false;

function svInitMenu() {
  var h   = document.getElementById('sv-header');
  var tog = document.getElementById('sv-menu-toggle');
  var mob = document.getElementById('sv-mobile-nav');
  if (!tog || !mob) return;

  var newTog = tog.cloneNode(true);
  tog.parentNode.replaceChild(newTog, tog);
  tog = newTog;

  tog.addEventListener('click', function (e) {
    e.stopPropagation();
    var isOpen = mob.classList.toggle('open');
    tog.classList.toggle('is-open', isOpen);
    tog.setAttribute('aria-expanded', String(isOpen));
    mob.setAttribute('aria-hidden', String(!isOpen));
  });

  mob.querySelectorAll('.sv-mob-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var sub    = this.nextElementSibling;
      var isOpen = !sub.classList.contains('open');
      sub.classList.toggle('open', isOpen);
      this.setAttribute('aria-expanded', String(isOpen));
      this.classList.toggle('active', isOpen);
    });
  });

  if (!_svDocClickBound) {
    _svDocClickBound = true;
    document.addEventListener('click', function (e) {
      var m = document.getElementById('sv-mobile-nav');
      var t = document.getElementById('sv-menu-toggle');
      var hdr = document.getElementById('sv-header');
      if (m && m.classList.contains('open') && hdr && !hdr.contains(e.target)) {
        m.classList.remove('open');
        if (t) { t.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); }
        m.setAttribute('aria-hidden', 'true');
      }
    });
  }

  if (h && !h._svScrollBound) {
    h._svScrollBound = true;
    window.addEventListener('scroll', function () {
      h.classList.toggle('scrolled', window.scrollY > 8);
    }, { passive: true });
  }
}

// ─────────────────────────────
// GSAP SCROLL ANIMATIONS
// ─────────────────────────────

function svInitGSAP() {
  // Skip if GSAP not loaded or user prefers reduced motion
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  gsap.registerPlugin(ScrollTrigger);

  // Stagger cards into view when their section enters the viewport
  document.querySelectorAll('.sv-prod-grid, .sv-prod-slider-track, .sv-coll-grid, .sv-related-grid').forEach(function(grid) {
    var cards = grid.querySelectorAll('.sv-prod-card');
    if (!cards.length) return;

    // Set initial hidden state
    gsap.set(cards, { opacity: 0, y: 36 });

    ScrollTrigger.create({
      trigger: grid,
      start: 'top 88%',
      once: true,
      onEnter: function() {
        gsap.to(cards, {
          opacity: 1,
          y: 0,
          duration: 0.65,
          stagger: 0.09,
          ease: 'power2.out',
          clearProps: 'transform,opacity' // let CSS take over after animation
        });
      }
    });
  });

  // Category cards stagger
  document.querySelectorAll('.sv-cat-grid').forEach(function(grid) {
    var cards = grid.querySelectorAll('.sv-cat-card');
    if (!cards.length) return;
    gsap.set(cards, { opacity: 0, y: 24 });
    ScrollTrigger.create({
      trigger: grid,
      start: 'top 88%',
      once: true,
      onEnter: function() {
        gsap.to(cards, {
          opacity: 1, y: 0,
          duration: 0.55,
          stagger: 0.07,
          ease: 'power2.out',
          clearProps: 'transform,opacity'
        });
      }
    });
  });

  // Section headings slide up
  document.querySelectorAll('.sv-prod-title, .sv-sh-title, .sv-cat-show-title').forEach(function(el) {
    gsap.set(el, { opacity: 0, y: 20 });
    ScrollTrigger.create({
      trigger: el,
      start: 'top 92%',
      once: true,
      onEnter: function() {
        gsap.to(el, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out', clearProps: 'all' });
      }
    });
  });
}

// ─────────────────────────────
// DOM READY
// ─────────────────────────────

function svDomReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    fn();
  }
}

svDomReady(function () {

  svInitMenu();
  svInitGSAP();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId && e.detail.sectionId.indexOf('header') !== -1) {
      svInitMenu();
    }
    // Re-run GSAP when sections reload in editor
    svInitGSAP();
  });

  // Qty buttons
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('sv-qty-minus')) {
      var wrap = e.target.closest('.sv-qty-wrap');
      var inp  = wrap && wrap.querySelector('input[type="number"]');
      if (inp) inp.value = Math.max(1, parseInt(inp.value || 1) - 1);
    }
    if (e.target.classList.contains('sv-qty-plus')) {
      var wrap = e.target.closest('.sv-qty-wrap');
      var inp  = wrap && wrap.querySelector('input[type="number"]');
      if (inp) inp.value = Math.min(99, parseInt(inp.value || 1) + 1);
    }
  });

  // Cart count
  svUpdateCartCount();

  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var headerH = (document.querySelector('.sv-header') || {}).offsetHeight || 0;
        window.scrollTo({ top: target.offsetTop - headerH - 16, behavior: 'smooth' });
      }
    });
  });

  // Newsletter feedback
  document.querySelectorAll('.sv-nl-form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) setTimeout(function () { btn.textContent = 'Thank you!'; btn.disabled = true; }, 300);
    });
  });

});
